import React from 'react';
import axios from 'axios';
import {toast} from "react-toastify";


class UserLogin extends React.Component {

    constructor(props) {
        super(props)
        this.state = {         
            username: '',
            password: ''
        }
    }

    handleChange = (event) => {
        const value = event.target.value;
        const name = event.target.name;
        this.setState({
            [name]: value
        });
    }

    handleSubmit = (event) => {
        const key = 'YUIKjuiKJIolkqUiWFDIE5LALyuiolSDwsDXCvBWzMq2gwWBvJcS8kl7RTYuJHTyuj';
        const url = `${localStorage.apiHost}/user-login`;
        let data = JSON.stringify({
            'username': this.state.username,
            'password': this.state.password,
            'program-id': localStorage.programId,
        });
        axios({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'key': key,
                "Content-Type" : "application/json"
            }

        }).then(response => {

            if (response.data.status === 200) {
                localStorage.token = response.headers.token;
                localStorage.isLogin = "true";
                this.props.onClick('true', response.data.name);
                toast.success(response.data.message);
                localStorage.userName = response.data.name;

                // console.log(response.data.name);
                    
            }else{
                toast.error(response.data.message);
                localStorage.isLogin = "false";
                this.props.onClick('false', '');
            }
        });
        event.preventDefault();
    }


    render() {

        return (
                <div className="px-4 py-1">
                   <form onSubmit={this.handleSubmit}>

                        <div className="form-group">
                            <label>Username <span className="text-danger">*</span></label>
                            <input onChange={this.handleChange} type="text" className="form-control" name="username" placeholder="Enter Your Username" required></input>
                        </div>

                        <div className="form-group mt-3">
                            <label>Password  <span className="text-danger">*</span></label>
                            <input id="pass" type="password" onChange={this.handleChange}className="form-control" name="password" placeholder="Password" required></input>
                        </div>
                       

                        <button type="submit" className="btn btn-md btn-info mt-3">Login</button>
                        
                        <>
                            <br></br>
                            {localStorage.forgetPassStatus == 1 && 
                                <>
                                    <p className="mt-3">
                                        <a id="forgetPass" data-dismiss="modal" className="pl-0 btn text-danger" data-toggle="modal" data-target="#forgetPassModal">
                                            Forgot Password?
                                        </a>
                                    </p>
                                </>
                            }
                            {localStorage.registerBtnStatus == 1 && 
                            <>
                                                       
                                <p>
                                    Do not have an account? &nbsp; 
                                    <a id="loginClose" data-dismiss="modal"  className={`${ this.props.programStatus == 3 ? "disabled" : ""} btn btn-primary btn-round mt-0 mb-2 border-0`} data-toggle="modal" data-target="#register" style={{background: localStorage.registerBtnBgColor, color:localStorage.registerBtnTextColor}}>
                                        Register
                                    </a>
                                </p>
                            </>
                            }
                        </>
                        
                    </form>
                </div>
        );
    }
}

export default UserLogin;